<div class="col-12" (click)="onOpenModal()" [ngClass]="{ hide: hide }">
  <div class="row" *ngIf="isOnlyIcon && numGuia == 0">
    <div class="col-icon-img" style="cursor: pointer;">
      <img src="assets/images/icons/paste_24px.svg" class="img-fluid" alt="" />
    </div>
  </div>
  <div *ngIf="!isOnlyIcon && numGuia == 0" style="text-align: end; margin-top: 0.5rem">
    <div>
      <label class="textHelp" style="cursor: pointer;">Ver guía</label>
    </div>
  </div>

  <div *ngIf="numGuia !=0" style="align-items: start;">
    <div>
      <label class="textHelp" style="cursor: pointer;"> {{numGuia}}</label>
    </div>
  </div>



</div>
<ng-template #contenidoModal>
  <div class="no-data" *ngIf="etapa.sinData">
    <div class="dashboard">
      <div class="mensajes mensaje-warning">
        <div class="mensajes-text">
          <strong>No se encontraron documentos asociados</strong>
        </div>
      </div>
      <div class="buttons">
        <a href="javascript:void(0)" (click)="goBack()" class="btn btn-primary btn-back btn-l-md"><i
            class="icon icon-back"></i>Volver</a>
      </div>
    </div>
  </div>

  <div class="dashboard custom-dashboard" *ngIf="etapa.MostrarData" style="padding: 1rem; padding-top: 0px">
    <div class="header-container">
      <h6 class="text-title"></h6>
      <button class="close-icon margin-cerrar" (click)="onCierrenModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="facturas text-size-sm d-flex justify-content-center">
      <div class="ancho-pdf">
        <div class="products contenido-impresion">
          <div class="card-box-body border-top-1 pt-4 pb-2 border-bottom-0">
            <div class="text-center">


              <!-- PDF -->
              <div *ngIf="esPdf" class="guia-pdf-host">
                <app-pdf-canvas-viewer [src]="effectiveSrc" [zoom]="pdfZoom"></app-pdf-canvas-viewer>
              </div>

              <!-- IMAGEN (TIF / JPG / PNG) -->
              <iframe *ngIf="esImagen" [src]="rutaDocumentoSafe" width="100%" height="600" style="border: none;">
              </iframe>
              <!-- FALLBACK -->
              <div *ngIf="!esPdf && !esImagen" class="alert alert-warning">
                Tipo de documento no soportado
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 d-md-flex justify-content-center">
      <!-- <div class="buttons mr-md-3">
        <a href="javascript:void(0)" (click)="goBack()" class="btn btn-volver"
          >Volver</a
        >
      </div> -->

      <div class="buttons">
        <a href="javascript:void(0)" (click)="eventoDescarPdf()" class="btn btn-primary btn-back btn-l-md">
          <i class="bi bi-download me-1"></i>Descargar guía</a>
      </div>
    </div>
  </div>
</ng-template>
